import {
  Article,
  Baseline,
  Block,
  BlockHeadline,
  Blocks,
  Header,
  Headline,
  Image,
  KeyPoint,
  KeyPoints,
  KeyPointsTitle,
  Main,
  Paragraph,
  Title,
} from "./style";

import BackButton from "../../../components/BackButton";
import { Helmet } from "react-helmet";
import React from "react";
import image1Cabinet from "./images/1-cabinet.png";
import image450000Plus from "./images/450000plus.png";
import image500Plus from "./images/500plus.png";
import image6Ingenieurs from "./images/6-ingenieurs.png";
import imageEmployee from "./images/employee.png";
import imageEssais from "./images/essais.jpg";
import imageExperts from "./images/experts.jpg";
import imageLightbulb from "./images/lightbulb.png";
import imageRemiseDAO from "./images/remise-dao.png";
import imageSampler from "./images/sampler.png";
import imageScreenDesktop from "./images/screen-desktop.png";
import imageShirt from "./images/shirt.png";
import imageTests from "./images/tests.jpg";
import imageWashingMachine from "./images/washing-machine.png";

export default function() {
  return (
    <Article
      aside={
        <KeyPoints>
          <KeyPointsTitle>Chiffres clés</KeyPointsTitle>
          <KeyPoint
            icon={imageEmployee}
            label={"textiles et habillement basés en France"}
          >
            <Image
              src={image6Ingenieurs}
              alt="6 ingénieurs"
              style={{ margin: -6 }}
            />
          </KeyPoint>
          <KeyPoint icon={imageSampler} label={"de style basé à Strasbourg"}>
            <Image src={image1Cabinet} alt="1 cabinet" style={{ margin: -6 }} />
          </KeyPoint>
          <KeyPoint icon={imageShirt} label={"nouveaux articles développés/an"}>
            <Image src={image500Plus} alt="+ 500" style={{ margin: -6 }} />
          </KeyPoint>
          <KeyPoint
            icon={imageWashingMachine}
            label={"tests de lavage matières et articles réalisés/an"}
          >
            <Image
              src={image450000Plus}
              alt="+ 450 000"
              style={{ margin: -6 }}
            />
          </KeyPoint>
          <KeyPoint icon={imageScreenDesktop} label={"sous 48 heures"}>
            <Image
              src={imageRemiseDAO}
              alt="Remise DAO"
              style={{ margin: -6 }}
            />
          </KeyPoint>
        </KeyPoints>
      }
      backButton={<BackButton to="/" />}
    >
      <Helmet>
        <title>L’innovation textile</title>
      </Helmet>
      <Header>
        <Headline icon={<Image src={imageLightbulb} />}>
          <Title>L'innovation au service</Title>
          <Title>
            <em>de votre métier</em>
          </Title>
        </Headline>
        <Baseline>
          Notre engagement : vous fournir des équipements qui vous protègent,
          vous valorisent et vous accompagnent durablement dans votre métier.
        </Baseline>
      </Header>
      <Main>
        <Blocks>
          <Block image={imageExperts}>
            <BlockHeadline>
              Nos experts <em>à votre service</em>
            </BlockHeadline>
            <Paragraph>
              Basé à <strong>Strasbourg</strong>, notre{" "}
              <strong>cabinet de style intégré</strong> réunit des{" "}
              <strong>
                ingénieurs textiles et des spécialistes de chaque secteur
                d’activité
              </strong>
              .
            </Paragraph>
            <Paragraph>
              Ensemble, ils conçoivent des vêtements professionnels alliant{" "}
              <strong>technicité, confort et durabilité</strong>, pensés pour
              répondre aux exigences concrètes de chaque métier.
            </Paragraph>
          </Block>
          <Block image={imageTests}>
            <BlockHeadline>
              Des tests produits exigeants, <em>gages de qualité durable</em>
            </BlockHeadline>
            <Paragraph>
              Chaque article est soumis à des <strong>tests rigoureux</strong>{" "}
              dans nos process d’entretien industriel.
            </Paragraph>
            <Paragraph>
              Ce protocole strict garantit la{" "}
              <strong>résistance, la fiabilité et la longévité</strong> de nos
              vêtements, pour que chaque port reste sûr et conforme dans le
              temps.
            </Paragraph>
          </Block>
          <Block image={imageEssais}>
            <BlockHeadline>
              Des essais au porté,
              <em>au plus près du terrain</em>
            </BlockHeadline>
            <Paragraph>
              Nos tenues professionnelles sont{" "}
              <strong>testées en conditions réelles</strong> par celles et ceux
              qui les portent.
            </Paragraph>
            <Paragraph>
              Ces <strong>essais réguliers</strong> garantissent un{" "}
              <strong>confort optimal</strong>, une liberté de mouvement et une{" "}
              <strong>fonctionnalité adaptée</strong> à chaque métier.
            </Paragraph>
          </Block>
        </Blocks>
      </Main>
    </Article>
  );
}
